// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b72429e0","453":"19b9da5d"}[chunkId] + ".chunk.js";
};